import React, { useEffect } from 'react'
import Navbar from '../../components/Navbar'
import FeatureHighlight from '../../components/cultivars/FeatureHighlight'
import ProductShowcase from '../../components/cultivars/MacDonut/ProductShowcase'
import Footer from '../../components/Footer'
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";
import { Helmet } from 'react-helmet'

const MacDonut = () => {
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
    <Helmet>
        <title>Mac Donut - Sweet Doughy Flavors & Balanced High | BeyondBloom™</title>
        <meta
          name="description"
          content="Mac Donut is a decadent cannabis strain with sweet, doughy flavors and a perfectly balanced high. Experience its unique aroma and effects today!"
        />
        <meta
          name="keywords"
          content="Mac Donut strain, sweet cannabis, doughy flavors, premium cannabis, balanced high, BeyondBloom"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta
          property="og:title"
          content="Mac Donut - Sweet Doughy Flavors & Balanced High | BeyondBloom™"
        />
        <meta
          property="og:description"
          content="Mac Donut is a decadent cannabis strain with sweet, doughy flavors and a perfectly balanced high. Experience its unique aroma and effects today!"
        />
        <meta property="og:image" content="/images/mac-donut.png" />
        <meta property="og:url" content="https://yourwebsite.com/cultivars/mac-donut" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Mac Donut - Sweet Doughy Flavors & Balanced High | BeyondBloom™"
        />
        <meta
          name="twitter:description"
          content="Mac Donut is a decadent cannabis strain with sweet, doughy flavors and a perfectly balanced high. Experience its unique aroma and effects today!"
        />
        <meta name="twitter:image" content="/images/mac-donut.png" />
      </Helmet>

    <Navbar/>
    <ProductShowcase/>
    <FeatureHighlight/>
    <CultivarDisplay />
    <Cta />
    <Footer/>
</>
  )
}

export default MacDonut